if (!customElements.get('dyefor-campaign-hero')) {
  customElements.define('dyefor-campaign-hero', class extends HTMLElement {
    connectedCallback() {
      this.events = new AbortController();
      const {signal} = this.events;
      this.headerSections = ['shopify-section-header', 'shopify-section-announcement-bar'].map(id => document.getElementById(id)).filter(Boolean);
      const measureHeader = () => {
        const height = this.headerSections.reduce((total, section) => total + section.offsetHeight, 0);
        document.body.style.setProperty('--dyefor-campaign-header-space', `${height}px`);
      };
      this.headerObserver = new ResizeObserver(measureHeader);
      this.headerSections.forEach(section => this.headerObserver.observe(section));
      measureHeader();
      this.slides = [...this.querySelectorAll('[data-campaign-slide]')];
      this.slides.forEach(slide => {
        const image = slide.querySelector('.dyefor-campaign__picture img');
        if (image) slide.style.setProperty('--dyefor-campaign-picture', `url(${JSON.stringify(image.src)})`);
      });
      this.selectors = [...this.querySelectorAll('[data-campaign-select]')];
      this.pauseButton = this.querySelector('[data-campaign-pause]');
      this.motion = matchMedia('(prefers-reduced-motion: reduce)');
      this.paused = this.motion.matches;
      this.studioWords = [...this.querySelectorAll('[data-studio-product]')];
      this.studioIndex = 0;
      this.studioPaused = false;
      this.studioWords.forEach((word, index) => word.toggleAttribute('data-active', index === 0));
      this.index = 0;
      this.querySelector('.dyefor-campaign__controls').hidden = false;
      this.selectors.forEach((button, index) => button.addEventListener('click', () => { this.paused = true; this.show(index); }, {signal}));
      this.pauseButton.addEventListener('click', () => { this.paused = !this.paused; this.studioPaused = this.paused; this.playback(); }, {signal});
      this.motion.addEventListener('change', () => { this.paused = this.motion.matches; this.playback(); }, {signal});
      this.addEventListener('mouseenter', () => { this.hovered = true; this.playback(); }, {signal});
      this.addEventListener('mouseleave', () => { this.hovered = false; this.playback(); }, {signal});
      this.addEventListener('focusin', () => this.playback(), {signal});
      this.addEventListener('focusout', () => requestAnimationFrame(() => this.playback()), {signal});
      document.addEventListener('visibilitychange', () => this.playback(), {signal});
      this.querySelector('.dyefor-campaign__controls').addEventListener('keydown', event => {
        if (!['ArrowLeft', 'ArrowRight'].includes(event.key)) return;
        event.preventDefault(); this.paused = true;
        this.show(this.index + (event.key === 'ArrowRight' ? 1 : -1));
        this.selectors[this.index].focus();
      }, {signal});
      const slidesRegion = this.querySelector('.dyefor-campaign__slides');
      slidesRegion.addEventListener('pointerdown', event => { this.pointer = event.pointerType === 'touch' ? [event.clientX, event.clientY] : null; }, {signal});
      slidesRegion.addEventListener('pointerup', event => {
        if (!this.pointer) return;
        const dx = event.clientX - this.pointer[0], dy = event.clientY - this.pointer[1];
        this.pointer = null;
        if (Math.abs(dx) < 60 || Math.abs(dy) > Math.abs(dx)) return;
        this.paused = true; this.show(this.index + (dx < 0 ? 1 : -1));
      }, {signal});
      const aiButton = this.querySelector('[data-campaign-ai]');
      this.aiButton = aiButton;
      aiButton.addEventListener('mouseenter', () => this.studioPlayback(), {signal});
      aiButton.addEventListener('mouseleave', () => this.studioPlayback(), {signal});
      aiButton.addEventListener('click', () => {
        const ai = this.closest('.dyefor-personal-home').querySelector('dyefor-ai-hero');
        if (typeof ai?.openChat !== 'function') return;
        this.paused = true; this.playback();
        ai.openChat();
        ai.modal.addEventListener('close', () => aiButton.focus({preventScroll: true}), {once: true});
      }, {signal});
      this.playback();
    }
    show(index) {
      this.index = (index + this.slides.length) % this.slides.length;
      this.slides.forEach((slide, i) => { slide.hidden = i !== this.index; slide.inert = i !== this.index; });
      this.selectors.forEach((button, i) => button.setAttribute('aria-pressed', String(i === this.index)));
      document.querySelector('dyefor-announcements')?.matchHero?.();
      this.playback();
    }
    playback() {
      clearTimeout(this.timer);
      this.studioPlayback();
      const label = this.paused ? 'Play slideshow' : 'Pause slideshow';
      this.pauseButton.setAttribute('aria-label', label); this.pauseButton.title = label;
      this.querySelector('[data-play-icon]').hidden = !this.paused;
      this.querySelector('[data-pause-icon]').hidden = this.paused;
      if (!this.paused && !this.hovered && !this.matches(':focus-within') && !document.hidden) this.timer = setTimeout(() => this.show(this.index + 1), 7000);
    }
    studioPlayback() {
      if (!this.isConnected || this.motion.matches || this.studioPaused || document.hidden || this.aiButton?.matches(':hover, :focus-within')) {
        clearInterval(this.studioTimer);
        this.studioTimer = null;
        return;
      }
      if (this.studioTimer || this.studioWords.length < 2) return;
      this.studioTimer = setInterval(() => {
        this.studioIndex = (this.studioIndex + 1) % this.studioWords.length;
        this.studioWords.forEach((word, index) => word.toggleAttribute('data-active', index === this.studioIndex));
      }, 1500);
    }
    disconnectedCallback() {
      clearInterval(this.studioTimer); this.studioTimer = null;
      clearTimeout(this.timer); this.events?.abort(); this.headerObserver?.disconnect();
      document.body.style.removeProperty('--dyefor-campaign-header-space');
    }
  });
}
